// Components
import TextField from 'components/General/TextField/TextField';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight as RightArrowIcon, faChevronDown as DownArrowIcon, faFolderOpen as OpenedFolderIcon, faFolder as ClosedFolderIcon } from '@fortawesome/free-solid-svg-icons';

// uuid
import { v4 as uuid } from 'uuid';

// Logic
import { useLogic } from './ReuseAssignment.logic';

// Style
import './ReuseAssignment.scss';

// Types
import { ReuseAssignment as IProps } from './ReuseAssignment.types';
import DotsLoader from 'components/General/Loader/Loader';

export const ReuseAssignment = ({ onReuseClick }: IProps) => {
  const {
    className,
    searchValue,
    OpenedFolder,
    isOpenFolder,
    setSearchValue,
    setIsOpenFolder,
    setOpenedFolder,
    handleSetReusableAssignment,
    reuseAssignmentData,
    isLoading,
    searchAssignments
  } = useLogic();
  return (
    <div className="reuse-assignemnt-container">
      <h2>Reuse assignments</h2>
      <div className="search-container">
        <TextField
          variant="rounded"
          placeholder="Search by class ID"
          value={searchValue || ''}
          onChange={(e: any) => setSearchValue(e.target.value)}
        />
      </div>
      {!isLoading ? (
        <div className="folders-container">
          {reuseAssignmentData ? (
            searchAssignments(searchValue)?.map((item) => (
              <div
                className="folder-container"
                key={uuid()}
              >
                <div className="folder-details">
                  <FontAwesomeIcon
                    icon={(isOpenFolder && item.id === OpenedFolder) ? DownArrowIcon : RightArrowIcon}
                    className="arrow-icon"
                    size="1x"
                    color="#696C71"
                    onClick={() => {
                      setIsOpenFolder(!isOpenFolder);
                      setOpenedFolder(item.id);
                    }}
                  />
                  <FontAwesomeIcon
                    icon={(isOpenFolder && item.id === OpenedFolder) ? OpenedFolderIcon : ClosedFolderIcon}
                    className="folder-icon"
                    size="1x"
                    color="#696C71"
                    onClick={() => {
                      setIsOpenFolder(!isOpenFolder);
                      setOpenedFolder(item.id);
                    }}
                  />
                  <h3>{`${className} Class #${item.classId}`}</h3>
                </div>
                {isOpenFolder && item.id === OpenedFolder && (
                <div className="assignments-container">
                  {item.assignments.length ? (
                    item.assignments.map((assignment) => (
                      <div
                        className="assignment"
                        key={uuid()}
                      >
                        <h3>{`${assignment.name} ${assignment.id}`}</h3>
                        <h3>
                          <a
                            href="#"
                            onClick={() => {
                              handleSetReusableAssignment({
                                id: assignment.id,
                                name: assignment.name,
                                dueDate: assignment.dueDate,
                                fullMark: assignment.fullMark,
                                details: assignment.details,
                                attachments: assignment.attachments
                              });
                              onReuseClick();
                            }}
                            type="button"
                          >
                            Reuse
                          </a>
                        </h3>
                      </div>
                    ))
                  ) : (
                    <h3>No assignments</h3>
                  )}
                </div>
                )}
              </div>
            ))
          ) : (
            <h2>No files found</h2>
          )}
        </div>
      ) : (
        <DotsLoader />
      )}
    </div>
  );
};
